<template>
  <!-- 新闻中心 -->
  <div class="News bg-round bg-fff">
    <div class="container" id="w-1200px">
      <Bread :list="breadList" class="ma-t-10" />
      <div class="flex">
        <div class="width70 pa-r-20">
          <div class="b-b-1-eee flex width100 overflow-auto b-b-1-e3">
            <div
              class="pa-30 c-p white-s-n"
              v-for="(item, index) in categoryList"
              :key="index"
              :class="{ 'tab-active': categoryId == item.Id }"
              @click="
                categoryId = item.Id;
                loadDataList('refresh');
              "
            >
              {{ item.Name }}
            </div>
          </div>
          <div class="ma-t-20">
            <div
              class="flex ma-b-20 c-p"
              v-for="(item, index) in dataList"
              :key="index"
              @click="toDetail(item.Id)"
            >
              <div class="flex flex-direction f-between  flex1  b-b-1-e3 pa-b-20">
                <div>
                  <div class="t-omit-1">
                  {{ item.Name }}
                </div>
                <div class="t-omit-2 c-666 ma-t-10 fon-14">
                  {{ item.Summary }}
                </div>
                </div>
                <div class="flex f-between c-666 ma-t-10 fon-14">
                  <div>{{ item.ReleaseTime }}</div>
                </div>
              </div>
            </div>
          </div>
          <Empty :isShow="!dataList || dataList.length==0"></Empty>
          <div class="fy t-center">
            <el-pagination
              @current-change="handleCurrentChange"
              :hide-on-single-page="true"
              :current-page.sync="pageIndex"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="totals"
            ></el-pagination>
          </div>
        </div>
        <div class="width30 pa-l-20">
          <div class="menu-item fon-24">
            <div class="font-bold">最热榜TOP10</div>
            <div class="font-bold">List TOP 10</div>
            <img
              src="../img/index/index21(1).png"
              class="item-right width50"
              alt=""
              srcset=""
            />
            <img
              src="../img/index/index22.png"
              class="item-left"
              alt=""
              srcset=""
            />
          </div>
          <div class="ma-t-20">
            <div
              class="flex ma-b-30 f-center"
              v-for="(item, index) in hotList"
              :key="index"
            >
              <div>
                <div
                  class="box-top  c-fff bg-topOther c-p"
                  :class="{
                    'bg-top1': index == 0,
                    'bg-top2': index == 1,
                    'bg-top3': index == 2,
                  }"
                >
                  {{ index + 1 }}
                </div>
              </div>
              <div>
                <div class="t-omit-1 pa-l-10 c-p" @click="toDetail(item.Id)">
                  {{ item.Name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsCategory, newsList, HomeArticle } from "../api.js";
export default {
  data() {
    return {
      breadList: [
        {
          name: "新闻中心",
          path: "/news/index",
        },
      ],
      categoryId: 0,
      pageIndex:1,
      pageSize:10,
      categoryList: [],
      dataList: [],
      hotList: [],
      totals: 0,
    };
  },
  created() {
    if(this.$route.query.categoryId){
      this.categoryId=this.$route.query.categoryId
    }
    this.loadData();
    this.loadDataList();
  },
  methods: {
    loadData() {
      newsCategory().then((res) => {
        this.categoryList = res.data.Data;
      });
      HomeArticle().then((res) => {
        this.hotList = res.data.Data;
      });
    },
    loadDataList(type) {
      if (type == "refresh") {
        this.pageIndex = 1;
      }
      newsList({
        categoryId: this.categoryId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data.List;
          this.totals = res.data.Data.TotalCount;
        }
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/news/detail", query: { id: id } });
    },
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.loadDataList();
    },
  },
};
</script>

<style lang="scss" scoped>
.News .container {
  min-height: 1150px;
  // background: #ffffff;
  box-sizing: border-box;
  padding: 30px 40px;
}

.tab-active {
  border-bottom: 4px solid #fb004d;
  color: #fb004d;
  font-weight: bold;
}

.menu-item {
  position: relative;

  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }

  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.box-top {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}
.bg-topOther {
  background: #bfbfbf;
}
.bg-top1 {
  background: #f9014b;
}
.bg-top2 {
  background: #eb6100;
}
.bg-top3 {
  background: #f8b551;
}
</style>